// extracted by mini-css-extract-plugin
module.exports = {"root":"az_GK","helper-left":"az_HK","helper-right":"az_IK"};